import { render, staticRenderFns } from "./EvolucionDiarioTab.vue?vue&type=template&id=a4c60fea&"
import script from "./EvolucionDiarioTab.vue?vue&type=script&lang=js&"
export * from "./EvolucionDiarioTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports